<template>
  <div id="modalComercio" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="Editando">Editar comercio</span>
            <span v-else>Crear comercio</span>
          </h5>
          <div class="acciones-modal">
            <button type="button" class="btn btn-success" @click="clickSave()">
              <font-awesome-icon v-if="!guardando" :icon="Icons.ACEPTAR" />
              <div v-else id="indicador-guardado" class="spinner-border" role="status"></div>
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="modal-body">
          <formulario-comercio ref="formulario" :editando="Editando" :esAdmin="true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { EstadoLogo } from "../../../data/enums";
import FormularioComercio from "../formularios/FormularioComercio.vue";
import { Icons as IconConstants } from "../../../constants";

/** Cuando se cerró el modal */
const EVENTO_CERRADO = "cerrado";
/** Cuando se terminó de crear */
const EVENTO_CREADO = "creado";
/** Cuando se terminó de editar */
const EVENTO_EDITADO = "editado";

export default {
  props: {
    facade: Function
  },
  components: {
    FontAwesomeIcon,

    FormularioComercio
  },
  data() {
    return {
      editando: false,
      guardando: false,
      modal: null
    };
  },
  computed: {
    Editando() {
      return this.editando;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    }
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    /**
     * @param {object} item Item editado, si no se pasa, se abre en modo creación
     */
    EventoAbrir(item = null) {
      this.$refs.formulario.limpiarFeedback();

      if (item) {
        this.editando = true;
        this.iniciarEdicion(item);
      } else {
        this.editando = false;
        this.iniciarCreacion();
      }
      this.modal.show();
    },
    EventoCerrar() {
      this.cerrar();
    },
    // ---------------- Métodos internos ---------------
    cerrar() {
      this.modal.hide();
    },
    // Este método es llamado por el evento de bootstrap cuando el modal se cierra
    cerrado() {
      this.$emit(EVENTO_CERRADO);
      this.limpiar();
    },
    async clickSave() {
      if (this.$refs.formulario.esValido()) {
        this.guardando = true;

        const item = this.$refs.formulario.item;
        const dtoComercio = this.comercioADTODeEnvio(item);

        if (this.Editando) {
          let willUpdate = true;

          if (item.minimumDiscountPercentage) {
            const hasBeneficioWithLowerDiscount = (
              await this.facade.hasBeneficioWithLowerDiscount(
                dtoComercio.id,
                item.minimumDiscountPercentage
              )
            ).data;

            if (hasBeneficioWithLowerDiscount) {
              const confirmationResult = await Swal.fire({
                title: "Atención!",
                text:
                  "Se actualizarán los beneficios con descuento menor al nuevo mínimo. ¿Continuar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "rgb(125 133 140)",
                confirmButtonText: "Si, actualizar",
                cancelButtonText: "Cancelar"
              });

              if (!confirmationResult.isConfirmed) {
                willUpdate = false;
              }
            }
          }

          if (willUpdate) {
            this.facade
              .update(dtoComercio)
              .then(() => this.comercioEditado())
              .catch(error => {
                console.error(error);
                this.guardando = false;
              });
          } else {
            this.guardando = false;
          }
        }
        // Se está creando
        else {

          this.facade
            .create(dtoComercio)
            .then(respuesta => {
              const comercioCreado = respuesta.data;

              if (this.$refs.formulario.getEstadoLogo() == EstadoLogo.nuevo) {
                this.subirLogo(comercioCreado.id)
                  .then(() => {
                    this.terminarCreacion();
                  })
                  .catch(error => {
                    console.error(error);
                  })
                  .finally(() => {
                    this.guardando = false;
                  });
              } else {
                this.guardando = false;
                this.terminarCreacion();
              }
            })
            .catch(error => {
              console.error(error);
              this.guardando = false;
            });
        }
      } else {
        this.$refs.formulario.mostrarFeedback();
      }
    },
    /**Devuelve el DTO de envío del comercio que se le pasa */
    comercioADTODeEnvio(item) {
      if (item.localidad == 0) {
        item.localidad = {
          id: 0
        }
      }

      let idCompaniasSeleccionadasList = [];

      if(item.companiasSeleccionadas){        
        item.companiasSeleccionadas.forEach(elemento =>
          idCompaniasSeleccionadasList.push(elemento.id)
        )
      }
      
      return {
        id: item.id,
        activo: item.activo,
        address: item.address,
        cuit: item.cuit,
        email: item.email,
        localidadId: item.localidad ? item.localidad.id : null,
        minimumDiscountPercentage: Number(item.minimumDiscountPercentage),
        name: item.name,
        phone: item.phone,
        whatsapp: item.whatsapp,
        urlWebsite: item.urlWebsite,
        urlFacebook: item.urlFacebook,
        urlInstagram: item.urlInstagram,
        urlQR: item.urlQR,
        excluyeCompanias: item.excluyeCompanias,
        companiasExcluidas: idCompaniasSeleccionadasList,
      };
    },
    iniciarCreacion() { },
    iniciarEdicion(item) {
      this.$refs.formulario.copiar(item);
    },
    /**Limpia los inputs de creación/edición */
    limpiar() {
      this.$refs.formulario.limpiar();
    },
    // Llamado cuando se recibe respuesta correcta luego de enviar una edición de comercio al servidor
    comercioEditado() {
      // Solo se guarda cuando es un logo nuevo y no el original
      if (this.$refs.formulario.getEstadoLogo() == EstadoLogo.nuevo) {
        this.subirLogo(this.$refs.formulario.item.id)
          .then(respuesta => {
            // Guardar el nombre del logo
            this.$refs.formulario.item.logo = respuesta.data.Name;
            this.terminarEdicion();
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.guardando = false;
          });
      } else {
        this.guardando = false;
        this.terminarEdicion();
      }
    },
    subirLogo(idComercio) {
      let formData = new FormData();
      formData.append("image", this.$refs.formulario.getArchivoLogo());
      return this.facade.uploadLogo(idComercio, formData);
    },
    terminarCreacion() {
      this.$emit(EVENTO_CREADO, this.$refs.formulario.item);
      this.cerrar();
    },
    terminarEdicion() {
      this.$emit(EVENTO_EDITADO, this.$refs.formulario.item);
      this.cerrar();
    }
  },
  mounted() {
    const elementoModal = document.getElementById("modalComercio");
    const opcionesModal = {};

    this.modal = new bootstrap.Modal(elementoModal, opcionesModal);

    // Escuchar al evento de cierre
    elementoModal.addEventListener("hidden.bs.modal", this.cerrado);
  }
};
</script>
<style scoped>
#indicador-guardado {
  width: 16px;
  height: 16px;
}
</style>
